function One(){
    return(
     <div className="gal">
       
        <div class="gal_1">
            <img src="/images/one.jfif" alt="Solo Levelling"></img>
            <h2>Sung Jinwoo VS Beru</h2>
            <p>Sung Jinwoo faces Ant King ina a brutal clash of Power</p>
            <button>Action</button>
         
        </div>
        <div className="gal_1">
            <img src="/images/nine.jpg" alt="Vegeta"></img>
            <h2>Vegeta's Sacrifice</h2>
            <p>Vegeta sacrifices himself to save the Earth from Buu</p>
            <button>Emotion</button>
        </div>

        <div class="gal_1">
            <img src="/images/Seven.jpg" alt="Solo Levelling"></img>
            <h2>Naruto Kurama Mode</h2>
            <p>Naruto unlocks the Kurama Chakra Mode in Ninja War</p>
            <button>Action</button>

        </div>

        <div class="gal_1">
            <img src="/images/four.jpg" alt="Solo Levelling"></img>
            <h2>Ace's Death</h2>
            <p>Ace's final stand - protecting Luffy till the End</p>
            <button>Emotion</button>
        </div>

    </div>
    )

}

export default One;